import { render, staticRenderFns } from "./MicrositesManager.vue?vue&type=template&id=207e56e7&"
import script from "./MicrositesManager.vue?vue&type=script&lang=ts&"
export * from "./MicrositesManager.vue?vue&type=script&lang=ts&"
import style0 from "./MicrositesManager.vue?vue&type=style&index=0&id=207e56e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports